export default "__VITE_ASSET__b0c95I3b__"